// utils/audioUtils.ts
export function createAudioBlob(audioData: string | ArrayBuffer): Blob {
  if (typeof audioData === 'string') {
    // Handle base64 string (your original code)
    const base64 = audioData.replace(/^data:audio\/\w+;base64,/, '');
    const byteString = atob(base64);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'audio/wav' });
  } else {
    // Handle ArrayBuffer directly (from Azure Speech SDK)
    return new Blob([audioData], { type: 'audio/wav' });
  }
}